import { render, staticRenderFns } from "./ModalServiceAnimals.vue?vue&type=template&id=24109c5e&scoped=true&"
import script from "./ModalServiceAnimals.vue?vue&type=script&lang=js&"
export * from "./ModalServiceAnimals.vue?vue&type=script&lang=js&"
import style0 from "./ModalServiceAnimals.vue?vue&type=style&index=0&id=24109c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24109c5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
